const initialState = {
  accounts: {
    type_of_loan: '',
  },
  contacts: {
    id_status: '',
    first_name: '',
    last_name: '',
    phone_mobile: '',
    email: '',
    area_you_service: [],
    appropriate_licensing: '',
    bridge_financing_per_yr: '',
    bridge_financing_per_month: '',
  },
  showError: false,
  forBorrower: {
    first_name: '',
    last_name: '',
    phone_mobile: '',
    email: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FORM_ACCOUNTS':
      return { ...state, accounts: { ...state.accounts, ...action.payload } };

    case 'SET_FORM_CONTACTS':
      return { ...state, contacts: { ...state.contacts, ...action.payload } };

    case 'SET_FORM_ERROR':
      return { ...state, showError: action.payload };

    case 'SET_FOR_BORROWER':
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/form.reducer.js